import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';
import WindowBrowser from "../components/browser-window";

const ProofOfConcept = () => {
  useEffect(() => {
    
  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Proof Of Concept</h1>
        <h3>Spot the fake. Safeguard the cure.</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Proof Of Concept
            </div>
            <Scrollspy
              // offset={-140}
              className="scrollspy" items={['Comparison', 'MST', 'ELONA', 'Development', 'Conclusion']}
              currentClassName="active">
              <li><a href="#Comparison">1. Comparing the Obtained Aptamer with the Original (A14#1)</a></li>
              <li><a href="#MST">2. Examining Binding Constants Using MST</a></li>
              <li><a href="#ELONA">3. Evaluating Aptamer Performance with ELONA</a></li>
              <li><a href="#Development">4. Developing a Semi-Quantitative LFA Device for Bevacizumab Detection</a></li>
              <li><a href="#Conclusion">Conclusion</a></li>

            </Scrollspy>
            <img
              src="https://static.igem.wiki/teams/5334/wiki-images/updated-mascot/mascot-holding-flask-3-1.webp"
              alt="Mascot with flask"
              
            />
          </div>

        </div>
        <div className="main_lab_style">
        <WindowBrowser description={
          <div> 
            <h1>
            Proof of Concept
            </h1>
            <br />
            <h1 id="Comparison">
            1. Comparing the Obtained Aptamer with the Original (A14#1)
            </h1>
            <p>
            Structural analysis and molecular dynamics simulations, conducted as part of the aptamer’s design, showed that the optimized aptamer CU2#19 retains its structural integrity while enhancing its specificity for Bevacizumab in comparison with A14#1. These simulations suggest that CU2#19 maintains key functional properties, such as selective binding to Bevacizumab in solution under near-physiological conditions.Based on the results from three different docking platforms (Autodock Vina, PatchDock, and Hex), and GROMACS total energy results, aptamer CU2#19 was selected as the final candidate for device development. 
            </p>

            <h1 id="MST">
            2. Examining Binding Constants Using MST
            </h1>
            <p>
            MST was employed to provide precise measurements of the binding constants of both aptamers. MST’s ability to analyze interactions in free solution without immobilization allowed us to closely mimic physiological conditions, ensuring that the native conformation of both aptamers was preserved. The results from three independent MST experiments confirmed that CU2#19 has a slightly stronger binding affinity (10.4 ± 1.5 nM) for bevacizumab compared to A14#1 (11.0 ± 3.7 nM) without statistical significance. Nevertheless, the dissociation constant (Kd) remains relatively high. Further experiments using ELONA will be conducted to confirm the sensitivity.
            </p>

            <h1 id="ELONA">
            3. Evaluating Aptamer Performance with ELONA
            </h1>
            <p>
            ELONA was used to validate the performance of CU2#19 and A14#1 in detecting Bevacizumab across a range of concentrations. The experiments demonstrated that CU2#19 showed significantly better sensitivity at lower concentrations of Bevacizumab compared to A14#1. While A14#1 struggled to produce clear signals at concentrations below 1 μg/ml, CU2#19 consistently detected Bevacizumab at concentrations as low as 0.01 μg/ml, with minimal variability.
            </p>
            <p>
            The enzymatic amplification provided by ELONA allowed us to quantify the aptamer-Bevacizumab interaction with high precision, revealing that CU2#19 provides not only stronger binding affinity but also enhanced sensitivity across a broad range of concentrations. This makes CU2#19 a suitable candidate for detecting Bevacizumab in diagnostic tests, including LFA-based systems, where both specificity and sensitivity are critical for accurate results.
            </p>

            <h1 id="Development">
            4. Developing a Semi-Quantitative LFA Device for Bevacizumab Detection
            </h1>
            <p>
            With the enhanced binding affinity and sensitivity of CU2#19 validated by MST and ELONA, the next step involves the development of a semi-quantitative lateral flow assay (LFA) for Bevacizumab detection. The competitive format, in which Bevacizumab in the sample competes with a labeled version for binding to CU2#19, provides a simple and effective way to visualize the presence of Bevacizumab. The use of gold nanoparticles ensures that the results are easy to interpret, with the intensity of the visual signal inversely related to the concentration of Bevacizumab in the sample.
            </p>
            <p>
            The addition of a control line incorporating the 24xT aptamer ensures that the LFA device is functioning correctly, generating a strong signal at the control line regardless of the Bevacizumab concentration. This internal control is crucial for ensuring test reliability in real-world applications, such as detecting counterfeit Bevacizumab in pharmaceutical samples.
            </p>
            <p>
            The LFA device will be optimized for sensitivity by leveraging the superior binding characteristics of CU2#19, ensuring it can detect even small amounts of Bevacizumab. The simplicity of the LFA platform, combined with the high sensitivity provided by CU2#19, makes it an ideal tool for point-of-care diagnostics or quick testing in environments where access to complex laboratory equipment is limited.
            </p>

            <h1 id="Conclusion">
              Conclusion
            </h1>
            <p>
            This proof of concept establishes that CU2#19 is a highly promising candidate for developing a semi-quantitative diagnostic device for Bevacizumab detection. By combining the strengths of MST and ELONA, we have achieved a comprehensive evaluation of the aptamer’s performance, ensuring that the LFA test strip will be both sensitive and reliable for detecting counterfeit Bevacizumab in real-world settings. Further optimization of the LFA format, incorporating CU2#19, will lead to the creation of a practical and user-friendly tool for doctors and patients.
            </p>
            
          </div>

        }/>
         

        </div>
      </section>
    </div>
  );
}

export default ProofOfConcept;
